import * as api from '@gitbook/api-client';
import { Icon } from '@gitbook/spine-icons';
import { type IconDefinition, renderIcon, Tooltip } from '@gitbook/spine-react';

const IMPACT_ICONS: Record<api.ConversationIssueImpact, IconDefinition> = {
    [api.ConversationIssueImpact.Low]: Icon.ScaleOneBar,
    [api.ConversationIssueImpact.Medium]: Icon.ScaleTwoBars,
    [api.ConversationIssueImpact.High]: Icon.ScaleThreeBars,
};

const IMPACT_LABELS: Record<api.ConversationIssueImpact, string> = {
    [api.ConversationIssueImpact.Low]: 'Low',
    [api.ConversationIssueImpact.Medium]: 'Medium',
    [api.ConversationIssueImpact.High]: 'High',
};

const IMPACT_TOOLTIPS: Record<api.ConversationIssueImpact, string> = {
    [api.ConversationIssueImpact.Low]:
        'Minor impact: users remain productive and can work around the issue.',
    [api.ConversationIssueImpact.Medium]:
        'Moderate impact: noticeable disruption, but users can still make progress.',
    [api.ConversationIssueImpact.High]:
        'Severe impact: critical functionality is blocked or severely degraded for users.',
};

/**
 * Icon and text span for an impact.
 */
export function ConversationIssueImpactSpan(props: { impact: api.ConversationIssueImpact }) {
    const { impact } = props;
    return (
        <Tooltip label={IMPACT_TOOLTIPS[impact]}>
            <span className="inline-flex gap-1">
                {renderIcon(IMPACT_ICONS[impact], { className: 'size-4 text-secondary' })}
                <span className="text-secondary text-ui-base">{IMPACT_LABELS[impact]}</span>
            </span>
        </Tooltip>
    );
}
